import { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

export const RangePricingTable = (props) => {
  const { rangePrice } = props;

  const [specialPriceContent, setSpecialPriceContent] = useState({});

  const createData = () => {
    let table = {};
    let columns = [];
    let rows = [];
    rangePrice.map((x) => {
      const header = (
        <TableCell
          align="center"
          size="small"
        >{`${x.fromQty} or more`}</TableCell>
        //>{`${x.fromQty} or ${x.toQty}`}</TableCell>
      );
      const row = (
        <TableCell align="center" size="small">
          ${x.specialPrice}
        </TableCell>
      );
      columns.push(header);
      rows.push(row);
    });
    table = { columns, rows };

    return table;
  };

  useEffect(() => {
    const table = createData();

    setSpecialPriceContent(table);
  }, [rangePrice]);
  return specialPriceContent?.columns ? (
    <TableContainer component={Paper} sx={{ marginBottom: "10px" }}>
      <Table
        sx={{ width: "100%", tableLayout: "fixed" }}
        aria-label="simple table"
      >
        <TableHead>
          <TableRow>
            <TableCell
              align="center"
              colSpan={specialPriceContent?.columns.length}
            >{`Special Prices:`}</TableCell>
          </TableRow>
          <TableRow>{specialPriceContent.columns.map((x) => x)}</TableRow>
        </TableHead>
        <TableBody>
          <TableRow key={7897877}>
            {specialPriceContent.rows.map((x) => x)}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  ) : null;
};
